module.exports = __webpack_public_path__ + "static/media/apple.6d1a3b88.png";